// import http from "./http-common";
import config from '../config'
import axios from 'axios'

const baseUrl = config.apiGateway.URL + config.apiGateway.VERSION
// class UploadFilesService {
//     upload(url, data, onUploadProgress) {
//         let to
//         // setFormData(data)
//         // formData.append("file", setFormData(data));
//         return http.post(url, setFormData(data), {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 "Content-Type": "multipart/form-data",
//             },
//             onUploadProgress,
//         });
//     }
//     getFiles() {
//         return http.get("/files");
//     }

   
// }

export const UploadFilesService = (url, type, data, params, onUploadProgress) => {
    // debugger

     const requestOptions = {
      method: type,
      url: baseUrl + url,
      headers: { "Content-Type": "multipart/form-data" },
      data: setFormData(data),
      params: params,
      onUploadProgress
    };

    // return fetch(baseUrl + url, requestOptions)
    return axios(requestOptions);
}

const setFormData  = (obj) =>{
    let formData = new FormData();
    console.log(Object.entries(obj))
    let entries = Object.entries(obj)
    entries.forEach(ele =>{
        console.log('ele...',ele)
        formData.append(ele[0], ele[1])
    })
    console.log(formData)
    return formData
    // debugger
}
export default UploadFilesService;